import { useAddEventUrl } from "../../hooks/useAddEventUrl";
import { useRandomAsset } from "../../hooks/useRandomAsset";

const WidgetPromotionalAsset = ({
	widgetType,
	utmSource,
	utmMedium,
	utmCampaign,
	customAdClasses,
}) => {
	const promotionalAsset = useRandomAsset(widgetType);
	const promoteUrl = useAddEventUrl({ utmSource, utmMedium, utmCampaign });

	if (!promotionalAsset) {
		return null;
	}

	return (
		<div className="c-card block row-span-2 relative overflow-hidden bg-white rounded border w-full @sm:max-w-lg m-auto">
			<div className={`flex items-center justify-center h-full p-1 evvnt-ad`}>
				<a href={promoteUrl} target="_blank" rel="noopener">
					<img
						src={promotionalAsset.image_url}
						className={customAdClasses}
						alt="Promote your event"
					/>
				</a>
			</div>
		</div>
	);
};

export default WidgetPromotionalAsset;
